<p-tree
  [value]="treeView$ | async"
  selectionMode="single"
  filterPlaceholder="Filter Presets"
  (onNodeSelect)="onNodeSelected($event)"
/>
<div class="actions">
  <p-button
    size="small"
    severity="secondary"
    label="Cancel"
    (onClick)="close()"
  ></p-button>
  <p-button
    icon="pi fi fi-rr-file-export"
    severity="primary"
    size="small"
    label="Move"
    [disabled]="!!!selected"
    (onClick)="move()"
  ></p-button>
</div>
